import { createFileRoute } from '@tanstack/react-router';
import { ReactFlowProvider } from '@xyflow/react';

import { NexusBuilder } from '@/features/nexus/NexusBuilder';
import { NexusStoreProvider } from '@/features/nexus/providers/NexusStoreProvider';
import { PageLayout } from '@/features/page-layout/PageLayout';

export const Route = createFileRoute('/_protected/t/$tenantId/nexus/library_/$templateId')({
  component: NexusTemplateViewRoute,
});

/**
 * A Library template in the full mapping view. The trailing `_` on `library_`
 * opts out of nesting under the Library page, so this renders the workbench
 * standalone rather than inside the grid.
 */
function NexusTemplateViewRoute() {
  const { templateId } = Route.useParams();

  return (
    <ReactFlowProvider>
      <NexusStoreProvider>
        <PageLayout header>
          <NexusBuilder source={{ kind: 'LIBRARY', templateId }} />
        </PageLayout>
      </NexusStoreProvider>
    </ReactFlowProvider>
  );
}
